import React from 'react';
import { colors } from 'helpers/colors';

/**
 * @deprecated this seems to use inner indents inside the svg, which is not a good practice. Consider using SvgCrossMarkOutlineV2 instead.
 */
function SvgCrossMarkOutline({ size = 30, color = colors.gray[700] }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M4.22982 4.22982C4.53624 3.92339 5.03304 3.92339 5.33946 4.22982L12 10.8904L18.6605 4.22982C18.967 3.9234 19.4638 3.9234 19.7702 4.22982C20.0766 4.53624 20.0766 5.03304 19.7702 5.33946L13.1096 12L19.7702 18.6605C20.0766 18.967 20.0766 19.4638 19.7702 19.7702C19.4638 20.0766 18.967 20.0766 18.6605 19.7702L12 13.1096L5.33946 19.7702C5.03304 20.0766 4.53624 20.0766 4.22982 19.7702C3.9234 19.4638 3.92339 18.967 4.22982 18.6605L10.8904 12L4.22982 5.33946C3.9234 5.03304 3.9234 4.53624 4.22982 4.22982Z"
        fill={color}
      />
    </svg>
  );
}

export default SvgCrossMarkOutline;
